import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = JSON.parse(localStorage.getItem('navigation'));
